import "client-only";

import type { InstallReferrerPlugin } from "@/lib/capacitor-bridge";
import { isShellUserAgent } from "@/lib/shell";

/** THE way client code reaches AdServices. Returns the injected
 *  @capgo/capacitor-install-referrer plugin only inside the iOS shell; null
 *  on the web, and null on a shell build that predates the plugin (builds
 *  1-6 all do), which therefore report nothing rather than erroring. */
export function installReferrer(): InstallReferrerPlugin | null {
  if (typeof window === "undefined") return null;
  if (!isShellUserAgent(navigator.userAgent)) return null;
  return window.Capacitor?.Plugins?.InstallReferrer ?? null;
}
